import getScheduleData from './../middlewares/schedule';

function FETCH_SCHEDULE_SUCCESS(days, sports, events) {
    return dispatch => dispatch({ type: 'FETCH_SCHEDULE_SUCCESS', days, sports, events });
}

function CLOSE_ALL_SCHEDULE_DAY_CARD() {
    return dispatch => dispatch({ type: 'CLOSE_ALL_SCHEDULE_DAY_CARD' });
}

function SHOW_SCHEDULE_DAY_CARD(sportName, date) {
    return dispatch => dispatch({ type: 'SHOW_SCHEDULE_DAY_CARD', sportName, date });
}

function CLOSE_SCHEDULE_DAY_CARD(sportName, date) {
    return dispatch => dispatch({ type: 'CLOSE_SCHEDULE_DAY_CARD', sportName, date });
}

export function FETCH_SCHEDULE() {
    return (dispatch, getState) => {
        const state = getState().schedule;
        if (state.days.length === 0) {
            getScheduleData()
                .then(({ days, sports, events }) =>
                    dispatch(FETCH_SCHEDULE_SUCCESS(days, sports, events)))
                .catch(() => dispatch(FETCH_SCHEDULE_ERROR()));
        }
        return dispatch({ type: 'FETCH_SCHEDULE' });
    };
}

export function FETCH_SCHEDULE_ERROR() {
    return dispatch => dispatch({ type: 'FETCH_SCHEDULE_ERROR' });
}

export function TOGGLE_SCHEDULE_SLIDER_CARD(id) {
    return dispatch => dispatch({ type: 'TOGGLE_SCHEDULE_SLIDER_CARD', id });
}

export function TOGGLE_SCHEDULE_SLIDER_DAY(id) {
    return dispatch => dispatch({ type: 'TOGGLE_SCHEDULE_SLIDER_DAY', id });
}

export function CLOSE_ALL_DAYS() {
    return dispatch => dispatch({ type: 'CLOSE_ALL_DAYS' });
}

export function TOGGLE_SCHEDULE_DAY_CARD(sportName, date) {
    return (dispatch, getState) => {
        const state = getState().schedule;
        if (state.sports[sportName][date].showCard === false) {
            dispatch(CLOSE_ALL_SCHEDULE_DAY_CARD());
            dispatch(SHOW_SCHEDULE_DAY_CARD(sportName, date));
        } else {
            dispatch(CLOSE_SCHEDULE_DAY_CARD(sportName, date));
        }
        return dispatch({ type: 'TOGGLE_SCHEDULE_DAY_CARD' });
    };
}



// WEBPACK FOOTER //
// ./src/actions/schedule-slider.js